import { useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Modal from "@mui/material/Modal";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  color: "text.primary",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

export default function (props) {
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const displayPartBrand = (brand) => {
    if (brand != "NULL") {
      return <Typography id="keep-mounted-modal-description">Brand: {brand}</Typography>;
    }
  };

  const displayMainPipingDiameter = (mainPipingDiameter) => {
    if (mainPipingDiameter != "NULL") {
      return <Typography id="keep-mounted-modal-description">Main Piping Diameter: {mainPipingDiameter}</Typography>;
    }
  };

  const displayMaterial = (material) => {
    if (material != "NULL") {
      return <Typography id="keep-mounted-modal-description">Material: {material}</Typography>;
    }
  };

  const displayType = (type) => {
    if (type != "NULL") {
      return <Typography id="keep-mounted-modal-description">Type: {type}</Typography>;
    }
  };

  const displaySystemType = (systemType) => {
    if (systemType != "NULL") {
      return <Typography id="keep-mounted-modal-description">System Type: {systemType}</Typography>;
    }
  };

  const displayPrice = (price) => {
    if (price != "NULL") {
      return <Typography id="keep-mounted-modal-description">Price: {price}</Typography>;
    }
  };

  return (
    <div>
      <Grid container direction="row">
        <Grid md={10} item>
          <Grid container align="left" direction="row" rowSpacing={.5}>
            <Grid item xs={2} md={2}>
              <Typography sx={{fontSize: ".6em"}}>Brand: </Typography>
            </Grid>
            <Grid item xs={10} md={10}>
              <Typography>{props.brand}</Typography>
            </Grid>
            <Grid item xs={2} md={2}>
              <Typography sx={{fontSize: ".6em"}}>Name: </Typography>
            </Grid>
            <Grid item xs={10} md={10}>
              <Typography>{props.name}</Typography>
            </Grid>
          </Grid>
        </Grid>
        <Grid xs={12} md={2} item>
          <Button sx={{ margin: "5px", padding: "10px", width: "100%", height: "60px" }} variant="contained" color="success" onClick={handleOpen}>
            Learn More
          </Button>
        </Grid>
      </Grid>
      <Divider />
      <Modal
        keepMounted
        open={open}
        onClose={handleClose}
        key={props.name}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
      >
        <Box sx={style}>
          <Typography id="keep-mounted-modal-title" variant="h5" component="h2">
            {props.name}
          </Typography>
          {displayPartBrand(props.brand)}
          {displayType(props.type)}
          {displayMaterial(props.material)}
          {displaySystemType(props.systemType)}
          {displayMainPipingDiameter(props.mainPipingDiameter)}
          {displayPrice(props.price)}
          <Button sx={{ marginTop: "10px", marginBottom: "5px" }} variant="contained" target="_blank" color="success" href={props.link}>
            <Typography>Visit the Manufacturer</Typography>
          </Button>
        </Box>
      </Modal>
    </div>
  );
}
